import { useState } from 'react'
import { GoogleLogin } from '@react-oauth/google'
import { loginWithGoogle } from '../auth'
import Spinner from '../components/Spinner'

export default function Login({ onLogin, message }) {
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold tracking-tight">QA Inventory Service</h1>
        </div>

        {/* Card */}
        <div className="bg-base-100 border border-base-300/80 rounded-xl p-6 shadow-2xl flex flex-col items-center gap-4">
          {message && !error && <p role="status" className="text-sm opacity-70 text-center">{message}</p>}
          {submitting ? (
            <Spinner size="md" />
          ) : (
            <GoogleLogin
              onSuccess={async (cred) => {
                if (submitting) return
                setError(null)
                setSubmitting(true)
                try {
                  const user = await loginWithGoogle(cred.credential)
                  onLogin(user)
                } catch (e) {
                  setError(e instanceof Error ? e.message : 'Sign-in failed')
                  setSubmitting(false)
                }
              }}
              onError={() => setError('Google sign-in failed')}
            />
          )}
          {error && <p role="alert" className="text-error text-sm">{error}</p>}
        </div>
      </div>
    </div>
  )
}
